export type FieldType = 'text' | 'checkbox';

export interface PdfFieldConfig {
  name: string;
  type: FieldType;
}

export interface PdfTemplateMapping {
  file: string;
  fields: Record<string, PdfFieldConfig>;
  signature?: string;
}

export const PDF_MAPPINGS: Record<string, PdfTemplateMapping> = {
  introducer: {
    file: 'images/introducer.pdf',

    fields: {
      repName: { name: 'Name of Representative', type: 'text' },
      interviewDate: { name: 'Date of interview', type: 'text' },
      repCode: { name: 'repCode', type: 'text' },
      nricNo: { name: 'nricNo', type: 'text' },
      contactNo: { name: 'contactNo', type: 'text' },
      branch: { name: 'branch', type: 'text' },
      representative: { name: 'representative', type: 'text' },
      introducer: { name: 'introducer', type: 'text' },
      note: { name: 'note', type: 'text' }
    },

    signature: 'RepresentativeSignature'
  }
};